import type {App} from 'vue';
import {WebStorageService, WebStorageServiceInterface, WebStorageServiceOptions} from '@/services/WebStorageService';

const storage: WebStorageServiceInterface = new WebStorageService(window.sessionStorage, {namespace: ''});

export function useStorage(): null | WebStorageServiceInterface {

    return storage;
}

export default {
    install(app: App, options: WebStorageServiceOptions): void {

        storage.setOptions({namespace: options.namespace})

        app.provide('$session', storage);
        app.config.globalProperties.$session = storage;
    }
}